import { StyleSheet } from 'aphrodite';
import { charmGray } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		marginTop: 40,
	},
	header: {
		color: charmGray,
		fontSize: 14,
		marginBottom: 12,
	},
	sectionLine: {
		borderTop: '1px solid #D3DBDE',
		marginBottom: 20,
		marginLeft: -40,
		marginRight: -40,
	},
	selectors: {
		display: 'grid',
		gridTemplateColumns: 'auto auto',
		gridTemplateRows: '60px 60px 60px',
		justifyItems: 'center',
		margin: '20px auto',
	},
});
